import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';
import logo from '../../assets/NSASLogo.png';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nsas-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-top">
        <Link to="/" className="logo-title">
          <img src={logo} alt="NSAS Logo" className="nsas-logo" />
          <div className="nsas-title desktop-title">
            Nepalese Student Association at Southeastern
          </div>
          <div className="nsas-title mobile-title">NSAS @ SLU</div>
        </Link>

        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      <nav className={`nsas-nav ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-bar" />
        <ul className="nav-links">
          <li>
            <Link to="/home" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/members" onClick={() => setMenuOpen(false)}>
              Members
            </Link>
          </li>
          <li>
            <Link to="/gallery" onClick={() => setMenuOpen(false)}>
              Gallery
            </Link>
          </li>
          <li>
            <Link to="/events" onClick={() => setMenuOpen(false)}>
              Events
            </Link>
          </li>
          <li>
            <Link to="/links" onClick={() => setMenuOpen(false)}>
              Related Links
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
